import { CSSProperties } from "react";
import { DEFAULT_DETAIL_FONT_SIZE, DETAIL_FONT_SIZES } from "@utils/Constants";

/**
 * Variable CSS que controla el tamaño de letra del detalle de productos en las
 * vistas de impresión. Se inyecta inline en el wrapper `.page` de `PrintPage` y
 * la consumen `template/PrintLayout/base-style.css` y `@printerVariation/generic.scss`.
 */
export const PRINT_DETAIL_FONT_SIZE_VAR = "--print-detail-font-size";

/**
 * Normaliza el valor guardado en `Suscription.detail_font_size`. Cualquier valor
 * ausente o fuera del catálogo cae al tamaño por defecto.
 */
export function normalizeDetailFontSize(detailFontSize?: string | null): string {
  const value = `${detailFontSize ?? ""}`;
  return value in DETAIL_FONT_SIZES ? value : DEFAULT_DETAIL_FONT_SIZE;
}

/**
 * Estilos inline con la variable CSS del tamaño de letra del detalle. Se aplican
 * inline (y no vía clase) para que sobrevivan a la serialización del DOM que hace
 * `renderRouteToHtml` al generar el PDF.
 */
export function getDetailFontSizeInlineStyles(detailFontSize?: string | null): CSSProperties {
  return {
    [PRINT_DETAIL_FONT_SIZE_VAR]: `${normalizeDetailFontSize(detailFontSize)}px`,
  } as CSSProperties;
}
